import { QueryClient } from '@tanstack/react-query';

/**
 * Shared React Query client for permissions resolution.
 * Permissions are fetched once per session and never refetched automatically.
 * @internal
 */
export const permissionsQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      staleTime: Infinity,
    },
  },
});
